import type { ReactNode } from "react"
import { createContext, useContext, useState } from "react"

import type { HelpCenterArticleVersion } from "@productlane/zero"

interface HelpCenterArticleContextType {
	previewVersion: HelpCenterArticleVersion | null
	setPreviewVersion: (version: HelpCenterArticleVersion | null) => void
}

const HelpCenterArticleContext =
	createContext<HelpCenterArticleContextType | null>(null)

export const useHelpCenterArticleContext = () => {
	const context = useContext(HelpCenterArticleContext)
	if (!context) {
		throw new Error(
			"useHelpCenterArticleContext must be used within a HelpCenterArticleProvider",
		)
	}
	return context
}

interface HelpCenterArticleProviderProps {
	children: ReactNode
}

export const HelpCenterArticleProvider = ({
	children,
}: HelpCenterArticleProviderProps) => {
	const [previewVersion, setPreviewVersion] =
		useState<HelpCenterArticleVersion | null>(null)

	return (
		<HelpCenterArticleContext.Provider
			value={{
				previewVersion,
				setPreviewVersion,
			}}
		>
			{children}
		</HelpCenterArticleContext.Provider>
	)
}
